module.exports = "/_next/static/images/back-a2aa3dc6e151e010289baea6c47421a9.svg";